import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IBrandWrapSectionProps {
  $bgColor?: string;
  $textColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

export const BrandWrapSection2 = styled.div<IBrandWrapSectionProps>`
  background: #fff;
  padding: 32px 0;

  ${({ $bgColor, $textColor, $pointColor, $emphasisTextColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};

      .content-sub-title,
      .content-title {
        color: ${$textColor};
      }

      .category-tab {
        .menubar-swiper {
          background: ${$bgColor};

          .swiper-slide {
            .menubar-item {
              .area-click {
                color: ${$textColor};
              }

              &.active .area-click {
                background: ${$pointColor};
                color: ${$emphasisTextColor};
                border: 1px solid ${$pointColor};
              }
            }
          }
        }

        .menu2line-item {
          &.active {
            background: ${$pointColor};
            border-color: ${$pointColor};

            .text {
              color: ${$emphasisTextColor};
            }
          }
        }
      }

      &.event-status-3 {
        .brand-product-list:after,
        .brand-container > .btn-more:after {
          background: ${$bgColor} !important;
          opacity: 0.6;
        }
      }

      .product-item .tag.tag-soldout {
        background: rgba(172, 172, 172, 0.15);
        color: #000;
      }
    `}

  .content-title,
  .content-sub-title {
    padding: 0 20px;

    + .event-brand-main,
    + .event-brand-sub {
      margin-top: 12px;
    }
  }

  .content-sub-title {
    margin-top: 4px;
  }

  .event-brand-main {
    margin-top: 12px;

    + .event-brand-sub,
    + .content-title {
      margin-top: 32px;
    }
  }

  /* 미도래(진행 예정) 탭 처리
     - 공통: 상품 리스트 딤 (쿠폰은 CouponItem2 status='comingsoon' 으로 자체 딤)
     - PC: 자세히보기 버튼도 딤 (.btn-more 는 isDesktop 일 때만 렌더)
     - MO: 자세히보기 버튼 비노출 (.btn-more-small 은 !isDesktop 일 때만 렌더) */
  &.event-status-3 {
    .brand-product-list:after,
    .brand-container > .btn-more:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.6);
      z-index: 1;
      cursor: initial;
    }

    /* 메인 브랜드 PC 의 .btn-more 는 .brand-product-list 안에 있어 위 딤에 함께 덮인다.
       서브 브랜드 PC 의 .btn-more 만 .brand-container 직계라 별도로 덮는다. */
    .brand-container > .btn-more {
      position: relative;
      pointer-events: none;
    }

    .btn-more-small {
      display: none;
    }
  }

  &.bg-type-black {
    background: #000;

    .content-title {
      color: #fff;
    }

    .content-sub-title {
      color: #777;
    }

    .category-tab {
      .menubar-swiper {
        background: #000;

        .menubar-item {
          &.active .area-click {
            color: #000;
            background: #fff;
            border: 1px solid #fff;
          }

          .area-click {
            color: #e2e2e2;
            border: 1px solid #333;
          }
        }
      }
    }

    &.event-status-3 {
      .brand-product-list:after,
      .brand-container > .btn-more:after {
        background: rgba(0, 0, 0, 0.6);
      }
    }
  }

  .category-tab {
    background: transparent;
    margin-top: 12px;

    .swiper-slide {
      .menubar-item {
        .area-click {
          background: transparent;
          border: 1px solid #e2e2e2;
          color: #000;
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 0')};

    .content-title,
    .content-sub-title {
      padding: 0 ${mixin.pxToVw('20')};

      + .event-brand-main,
      + .event-brand-sub {
        margin-top: ${mixin.pxToVw('12')};
      }
    }

    .content-sub-title {
      margin-top: ${mixin.pxToVw('4')};
    }

    .event-brand-main {
      margin-top: ${mixin.pxToVw('12')};

      + .event-brand-sub,
      + .content-title {
        margin-top: ${mixin.pxToVw('32')};
      }
    }

    .category-tab {
      margin-top: ${mixin.pxToVw('12')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 57px;

    .content-title,
    .content-sub-title {
      padding: 0;
      margin: 0 auto;

      + .event-brand-main,
      + .event-brand-sub {
        margin-top: 20px;
      }
    }

    .content-title {
      font-size: 42px;
      line-height: 130%;
    }

    .content-sub-title {
      font-size: 18px;
      line-height: 135%;
      margin-top: 6px;
    }

    .event-brand-main {
      margin-top: 40px;

      + .event-brand-sub,
      + .content-title {
        margin-top: 112px;
      }
    }

    &.bg-type-black {
      .category-tab {
        .menu2line-item {
          color: #ccc;
          border-color: #555;

          &.active {
            background: #fff;

            .text {
              color: #000;
            }
          }
        }
      }
    }

    .category-tab {
      ${mixin.flex({ wrap: 'wrap', justify: 'flex-start' })};
      gap: 12px;
      margin-top: 16px;
    }
  }
`;

export const TabMenu = styled.div`
  margin-top: 12px;

  .tab-list {
    .swiper {
      padding: 0 20px;

      .swiper-wrapper {
        align-items: center;

        .swiper-slide {
          width: auto !important;

          &:last-child {
            margin-right: 0 !important;
          }
        }
      }
    }
  }

  + .event-brand-sub {
    margin-top: 14px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    margin-top: ${mixin.pxToVw('12')};

    .tab-list {
      .swiper {
        padding: ${mixin.pxToVw('0 20')};
      }
    }

    + .event-brand-sub {
      margin-top: ${mixin.pxToVw('14')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    margin: 40px auto 0;

    .tab-list {
      ${mixin.flex({ justify: 'start', align: 'center', wrap: 'wrap' })};
      gap: 12px;
    }

    + .event-brand-sub {
      margin-top: 40px;
    }
  }
`;
